module.exports = __webpack_public_path__ + "img/暂无积分及等级记录@2x.e4228ecf.png";